import dayjs from 'dayjs';
import en from 'dayjs/locale/en';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.locale({
    ...en,
    weekStart: 1,
});

// call tz() to use default module timezone (local time for main, UTC for admin)

export function getDateFormat(date?: string | Date) {
    return dayjs(date).tz().format('DD MMM YYYY');
}

export function extractDateOnly(date: string | Date) {
    return dayjs(date).format('YYYY-MM-DD');
}

export function extractWeekOnly(date: string | Date) {
    const instanceDate = dayjs(date);
    return [instanceDate.format('YYYY-MM'), 'Week:', instanceDate.week()].join(' ');
}

export function extractMonthOnly(date: string | Date) {
    return dayjs(date).format('YYYY-MM');
}

export function formatDate(date?: Date | string | null, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!date) {
        return 'N/A';
    }

    return dayjs(date).tz().format(format);
}

export function subtractDate(date: string | Date, value: number, type: dayjs.ManipulateType) {
    return dayjs(date).subtract(value, type).format('YYYY-MM-DD');
}

export function getWeekDateRange(date: string | Date) {
    const inst =  dayjs(date);
    return {
        dateFrom: inst.startOf('week').format('YYYY-MM-DDT00:00:00Z'),
        dateTo: inst.endOf('week').format('YYYY-MM-DDT23:59:59Z'),
    };
}

export function getFormattedMinutesFromSeconds(val: number) {
    const minutes = Math.max(Math.floor(val / 60), 0);
    const seconds = Math.max(val % 60, 0);

    return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
}

export const remainingTimeToResendVerificationEmail = (
    timeCreated: Date | string = new Date(0),
    currentDate = new Date()
) =>
    dayjs(timeCreated).add(10, 'minute').diff(currentDate);

export const formattedRemainingTimeToResendEmail = (remainingTime: number) =>
    dayjs(remainingTime).add(1, 'minute').format('m');

dayjs.extend(weekOfYear);
dayjs.extend(utc);
dayjs.extend(isoWeek);
dayjs.extend(duration);
dayjs.extend(timezone);

dayjs.tz.setDefault();

export { dayjs };
